import { MotionConfig } from "framer-motion";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { SmoothScrollProvider } from "@/context/SmoothScrollContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import IdentityStrip from "@/components/IdentityStrip";
import About from "@/components/About";
import Priorities from "@/components/Priorities";
import Gallery from "@/components/Gallery";
import InTheNews from "@/components/InTheNews";
import Marquee from "@/components/Marquee";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <LanguageProvider>
        <SmoothScrollProvider>
          <div className="App bg-[#F7F5F0] text-[#171717] antialiased">
            <Header />
            <main>
              <Hero />
              <IdentityStrip />
              <About />
              <Priorities />
              <Gallery />
              <InTheNews />
              <Marquee />
              <Contact />
            </main>
            <Footer />
          </div>
        </SmoothScrollProvider>
      </LanguageProvider>
    </MotionConfig>
  );
}

export default App;
